import { render, staticRenderFns } from "./assetListTransfer.vue?vue&type=template&id=e6c40994&"
import script from "./assetListTransfer.vue?vue&type=script&lang=js&"
export * from "./assetListTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports